import { render, staticRenderFns } from "./AssociacaoPerfilUsuarioList.vue?vue&type=template&id=cf50b370"
import script from "./AssociacaoPerfilUsuarioList.vue?vue&type=script&lang=js"
export * from "./AssociacaoPerfilUsuarioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports